import styled from 'styled-components';
import { Flex } from '../../../ui';

export const PasswordContainer = styled(Flex)`
  flex-direction: row;
  align-items: center;

  svg {
    margin-left: 0.6rem;
  }
`;
